module.exports = __webpack_public_path__ + "img/stopwatch-fill.78133d35.svg";